import React, { FC } from 'react';
// import { Outlet } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Container from '@/components/Container';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%', height: '100vh' }}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const AdminStatistics: FC = () => {
  const { t: tCommon } = useTranslation('common');
  const adminStatsUrl =
    'https://plausible.io/share/admin2.museum24.no?embed=true&background=transparent&auth=dCyGC9N2Md4-UURqkYUBR';
  const rollupStatsUrl =
    'https://plausible.io/share/rollup.museum24?embed=true&background=transparent&auth=TWwA3-E06TUajue2aZH1w';

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container p={2} gap={2} fullWidth fullHeight top left column>
      <Typography variant='h3' sx={{ component: 'h1', fontSize: 30 }}>
        {tCommon('Statistics')}
      </Typography>

      <Tabs
        value={value}
        onChange={handleChange}
        textColor='secondary'
        slotProps={{
          indicator: {
            style: {
              background: 'black',
            },
          },
        }}>
        <Tab label='Admin stats' {...a11yProps(0)} />
        <Tab label='Portal stats (rollup)' {...a11yProps(1)} />
      </Tabs>

      <CustomTabPanel value={value} index={0}>
        <iframe
          loading='lazy'
          title='Plausible Statistics'
          src={adminStatsUrl}
          style={{ border: 'none', width: '100%', height: '2200px' }}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <iframe
          loading='lazy'
          title='Plausible Statistics'
          src={rollupStatsUrl}
          style={{ border: 'none', width: '100%', height: '2200px' }}
        />
      </CustomTabPanel>

      <script async src='https://plausible.io/js/embed.host.js' />
    </Container>
  );
};
